import { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { Crown, X, Sparkle } from "@phosphor-icons/react";
import PremiumUpgrade from "./PremiumUpgrade";

export default function TrialBanner() {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(false);
  const [showModal, setShowModal] = useState(false);

  if (!user || user.is_premium || dismissed) return null;

  const inTrial = user.in_trial;
  const daysLeft = user.trial_days_left;
  const freeReflectionsLeft = Math.max(0, 1 - (user.free_reflections_used || 0));

  // Don't show if no trial and no free reflections
  if (!inTrial && freeReflectionsLeft <= 0) return null;

  return (
    <>
      <div
        className="mb-4 rounded-2xl p-3.5 flex items-center gap-3 border border-[#F4A261]/20"
        style={{ backgroundColor: "#FEF8F0" }}
        data-testid="trial-banner"
      >
        <div className="w-8 h-8 rounded-lg bg-[#F4A261]/15 flex items-center justify-center shrink-0">
          {inTrial ? <Crown size={16} weight="fill" className="text-[#F4A261]" /> : <Sparkle size={16} weight="duotone" className="text-[#F4A261]" />}
        </div>
        <div className="flex-1 min-w-0">
          {inTrial ? (
            <p className="text-sm text-[#1A2421]">
              <span className="font-semibold">Premium trial</span> — {daysLeft} {daysLeft === 1 ? "day" : "days"} remaining. Enjoy AI reflections & advanced insights.
            </p>
          ) : (
            <p className="text-sm text-[#1A2421]">
              <span className="font-semibold">{freeReflectionsLeft} free AI reflection</span> remaining. Upgrade for unlimited.
            </p>
          )}
        </div>
        <button
          onClick={() => setShowModal(true)}
          data-testid="trial-upgrade-button"
          className="shrink-0 px-3 py-1.5 rounded-full bg-[#2D6A4F] text-white text-xs font-semibold hover:bg-[#1B4936] transition-all"
        >
          Upgrade
        </button>
        <button
          onClick={() => setDismissed(true)}
          className="shrink-0 text-[#78857F] hover:text-[#1A2421] p-1"
          data-testid="dismiss-trial-banner"
        >
          <X size={14} />
        </button>
      </div>

      <PremiumUpgrade isOpen={showModal} onClose={() => setShowModal(false)} />
    </>
  );
}
